// extracted by mini-css-extract-plugin
module.exports = {"virusLogo":"virusButton_virusLogo__22ciz","virusLogoContainer":"virusButton_virusLogoContainer__cfdN1"};